import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { MultiSelectRowFormItemData } from "../_components/SettingFormItems"

export const getFilteredOptionsForMultiSelect = (
    keys: Maybe<string[]>,
    options: MultiSelectRowFormItemData[]
): MultiSelectRowFormItemData[] => {
    return options
        .filter(type => (keys ?? []).includes(type.key))
        .map(type => ({
            key: type.key,
            label: type.label,
        }))
}

export const mapMultiSelectLabelToKey = (label: string, options: MultiSelectRowFormItemData[]): Maybe<string> => {
    return options.find(option => option.label === label)?.key ?? null
}

export const handleTextAreaValue = (values, key: string, stateValue: Maybe<boolean>) => {
    if (!stateValue && stateValue !== undefined) {
        return []
    }
    if (values[key] === undefined) {
        return undefined
    }

    return values[key] && values[key] !== "" ? values[key].split("\n") : []
}
